// Initiate downloading of the blob data as a file
export default function downloadBlobFile (
  blob: Blob,
  fileName: string = 'download',
  extension: string = 'zip'
) {
  if (blob !== null) {
    const a = document.createElement('a')
    a.style.display = 'none'
    document.body.appendChild(a)

    const url = (a.href = window.URL.createObjectURL(
      new Blob([blob], { type: 'octet/stream' })
    ))
    a.download =
      extension === '' || extension === null
        ? fileName
        : `${fileName}.${extension}`
    a.click()

    setTimeout(() => {
      document.body.removeChild(a)
      window.URL.revokeObjectURL(url)
    }, 100)
  }
}
